import { takeEvery, delay } from 'redux-saga';
import { put, select, race, call, fork } from 'redux-saga/effects';
import { reducerActions, sagaActions } from './cartConsts';
import storeSdk from 'wix-art-store-3rd-party/dist/src/sdk';
import { serverApi } from '../../common/fetchx';
import ShoppingData from '../../business/jsonWrappers/ShoppingData';
import biLogger from '../biLogger/biLogger';
import fedOpsSagas from '../common/fedOps/fedOpsSagas';
import { validateCartItems } from '../../business/validation/validateCartItems';
import fedops from '../common/fedOps/FedOps';

function* changeItemPurchaseAttributes(action) {
  yield delay(1);
  const { item, license, quality } = action.payload;

  item.selectedLicenseId = license;
  item.selectedQualityId = quality;
  storeSdk.cart.updateItem(item.uuid, { metadata: item });
}

function* goToCheckout(action) {
  const {
    cartItems,
    userId,
    shoppingData,
    site: { localeInfo }
  } = yield select(state => state);

  const areCartItemsValid = validateCartItems(cartItems);
  if (areCartItemsValid) {
    const siteUrls = yield storeSdk.cart.getSiteInfo();
    fedops.interactionStarted('checkout');
    const objUrlParams = {};
    if (action.payload) {
      const { srcId, appDefId } = action.payload;
      srcId && (objUrlParams.srcId = srcId);
      appDefId && (objUrlParams.appDefId = appDefId);
    }
    const { success, response, errorCode, responseError } = yield serverApi('checkout', { cartItems, siteUrls, userId }, 'POST', objUrlParams);
    if (responseError) {
      console.error(`Cart - checkout - error:`, errorCode, responseError);
    } else if (success) {
      fedops.interactionEnded('checkout');

      try {
        const objShoppingData = new ShoppingData(shoppingData);
        const visitorId = userId;
        const currency = localeInfo.currency;
        const count = cartItems.length;
        const totalPrice = cartItems.reduce((previousValue, currencItem) => {
          const { galleryId, selectedLicenseId, selectedQualityId } = currencItem;
          const pricing = objShoppingData.getPricing(galleryId, selectedLicenseId, selectedQualityId);
          return previousValue + pricing.price;
        }, 0);

        yield race({
          logger: call(biLogger.cartCheckout.bind(biLogger), visitorId, currency, count, totalPrice),
          timeout: call(delay, 1000)
        });
      } catch (error) {
        console.error(error);
      }

      storeSdk.cart.checkout({ additionalParams: response });
    } else {
      // TODO: TAL - handle errorCode
    }
  } else {
    // TODO: TAL - handle this.
  }
}

function* removeCartItem(action) {
  yield delay(1);
  const { payload } = action;
  storeSdk.cart.removeItem(payload.uuid);
  //TBD -  might change accord to pro gallery hardenings and other needs that will be discussed in the futrue with tal and everybody in the world
}

function* setCartItems(action) {
  const { payload } = action;
  yield delay(1);
  const arrItemIdsToRemove = [];
  const { shoppingData } = yield select(state => state);

  const objShoppingData = new ShoppingData(shoppingData);

  const cartItems = (payload || []).filter(cartItem => {
    const { uuid, galleryId, selectedLicenseId, selectedQualityId } = cartItem;
    const exists = objShoppingData.getPricing(galleryId, selectedLicenseId, selectedQualityId);

    if (!exists) {
      arrItemIdsToRemove.push(uuid);
    }

    return exists;
  });

  arrItemIdsToRemove.forEach(itemUUID => {
    storeSdk.cart.removeItem(itemUUID);
  });

  yield put({ type: reducerActions.setCartItems, payload: cartItems });
}

function* cartSagas() {
  yield [
    fork(fedOpsSagas),
    takeEvery(sagaActions.changeItemPurchaseAttributes, changeItemPurchaseAttributes),
    takeEvery(sagaActions.removeCartItem, removeCartItem),
    takeEvery(sagaActions.goToCheckout, goToCheckout),
    takeEvery(sagaActions.setCartItems, setCartItems)
  ];
}

export default cartSagas;
